import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { BaseFormErrorTranslateService } from '../../forms/form-common-error/base-form-error-translate.service';
import { ErrorTranslateService } from '../../forms/error-translate-service';
import { INewsletterSubscription } from '../../../_interfaces/newsletter-subscription.interface';
import { SdBorderWrapperComponent } from '../../wrapper/border-wrapper/border-wrapper.component';
import { SdFormCheckboxComponent } from '../../forms/form-checkbox/form-checkbox.component';
import { SdTitleComponent } from '../../title/title.component';

@Component({
  selector: 'sd-newsletter-subscription',
  templateUrl: './newsletter-subscription.component.html',
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdTitleComponent,
    SdFormCheckboxComponent,
    TranslateModule
  ],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
export class SdNewsletterSubscriptionComponent implements OnInit {
  newsletterList = new Map<string, boolean>();

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 4;

  @Input()
  data: INewsletterSubscription[];

  @Output()
  newsletterSelected = new EventEmitter<Map<string, boolean>>();

  ngOnInit() {
    for (const item of this.data) {
      this.newsletterList.set(item.value, item.selected);
    }
  }

  updateCheckboxStatus(event: boolean, value: string) {
    this.newsletterList.set(value, event);
  }

  updateNewsletterStatus() {
    this.newsletterSelected.emit(this.newsletterList);
  }
}
